// extracted by css-extract-rspack-plugin
export default {"cls1":"ClaimDetails-cls1_gD2","cls2":"ClaimDetails-cls2_k7Q ClaimDetails-cls1_gD2"};